<template lang="pug">
  b-modal#addIp(
  ref="addIp"
  :title="$t('ui.combine.add_ip')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_ip"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_ip.$dirty"
          :error="$v.dataAdd_ip.$error"
          v-model.trim.lazy="$v.dataAdd_ip.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_ip.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_ip" :name="$t('ui.ip')")
      b-form-group(:label="$t('ui.remark')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_remark"
          type="text"
          :dirty="$v.dataAdd_remark.$dirty"
          :error="$v.dataAdd_remark.$error"
          v-model.trim.lazy="$v.dataAdd_remark.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_remark.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_remark" :name="$t('ui.remark')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, helpers, ipAddress } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
// const ipRule = helpers.regex('ipRule', /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_ip: "",
      dataAdd_remark: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_ip: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30),
      ipAddress
    },
    dataAdd_remark: {
      maxLength: maxLength(200)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addIpUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.ip,
          ip: this.dataAdd_ip,
          remark: this.dataAdd_remark
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_ip);
                  this.$refs.addIp.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_ip", this.feedback.status);
                  this.$refs.addIp.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_ip = "";
      this.dataAdd_remark = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_ip.$el.focus();
    }
  }
};
</script>
